// Live projects and case studies for TechsFlow
export const projects = [
  {
    slug: 'aurederma-institute',
    name: 'Aurederma Institute',
    industry: 'Dermatology',
    location: 'Nagpur',
    url: 'https://auredermainstitute.in/',
    description:
        'A composed digital presence for Aurederma Institute - designed to feel like a considered clinic visit rather than a webpage.',
    scope: ['Brand direction', 'Web design', 'Frontend build'],
    stack: ['React', 'Tailwind', 'Framer Motion'],
    image: '/image-aurederma.webp',
    palette: ['#EBF0E4', '#1E3A2A', '#B79155'],
    metrics: [
      { label: 'Consultation enquiries', value: '+184%' },
      { label: 'Time on site',            value: '3m 42s' },
    ],
    featured: true,
  },
  {
    slug: 'sukanya-ram-saxena-foundation',
    name: 'Sukanya Ram Saxena Foundation',
    industry: 'Nonprofit',
    location: 'Pune',
    url: 'https://sukanyaramsaxenafoundation.org',
    description:
      'A digital home for an inclusion-first nonprofit — built to carry the voice of the differently abled, underprivileged communities, and the initiatives that celebrate every ability.',
    scope: ['Website design', 'Frontend build', 'Inquiry system'],
    stack: ['React', 'Tailwind'],
    image: '/image-srsfoundation.webp',
    palette: ['#F1ECDF', '#252523', '#9C7A57'],
    featured: true,
  },
  {
    slug: 'ridaan-array',
    name: 'Ridaan Array',
    industry: 'Events',
    location: 'Pune',
    url: 'https://ridaanarray.com/',
    description:
      'A creative experience company that crafts connections — from corporate events and exhibitions to flea markets, art workshops, and bespoke gifting, all brought together under one considered digital identity.',
    scope: ['Website design', 'Frontend build', 'Inquiry system'],
    stack: ['React', 'Tailwind'],
    image: '/image-ridaanarray.webp',
    palette: ['#EFE7D8', '#25201A', '#C08A55'],
    featured: true,
  },
  {
    slug: 'hotel-maharaja-ravet',
    name: 'Hotel Maharaja Restaurant',
    industry: 'Hospitality',
    location: 'Pune',
    url: 'https://hotelmaharajaravet.netlify.app/',
    description:
      'A hospitality site that lets the food do the talking — warm photography, restrained motion, an unhurried menu.',
    scope: ['Website design', 'Frontend build'],
    stack: ['React', 'Tailwind'],
    image: '/image-hotelmaharaja.webp',
    palette: ['#1B120A', '#E58A2A', '#F6E7CA'],
  },
  {
    slug: 'dr-dnyaneshwar-kadam',
    name: 'Dr Dnyaneshwar Kadam',
    industry: 'Physician',
    location: 'Pimpri-Chinchwad',
    url: 'https://drdynaneshwarkadam.netlify.app/',
    description:
      'A personal practitioner site that reads like an editorial profile — calm typography, no clinical clichés.',
    scope: ['Personal brand site', 'Frontend build'],
    stack: ['React', 'Tailwind'],
    image: '/image-dnyaneshwarclinic.webp',
    palette: ['#EEF1FF', '#0E1130', '#5D6BF4'],
  },
];

// export const industries = [
//   { name: 'Dermatology',        note: 'Skin as identity.',              count: 4 },
//   { name: 'Dental',             note: 'Trust before technique.',        count: 3 },
//   { name: 'Aesthetic Clinics',  note: 'The quiet kind of luxury.',      count: 2 },
//   { name: 'Hair Clinics',       note: 'Confidence, on a schedule.',     count: 2 },
//   { name: 'Cosmetic Surgery',   note: 'Precision meets warmth.',        count: 2 },
//   { name: 'Physicians',         note: 'A digital second opinion.',      count: 3 },
//   { name: 'Hospitality',        note: 'Where the room speaks first.',   count: 1 },
//   { name: 'Nonprofits',         note: 'Cause, told with care.',         count: 1 },
// ];

export const industries = [
  { no: "01", title: "Dermatology", subtitle: "Where science meets self-confidence." },
  { no: "02", title: "Dental", subtitle: "Modern care behind every smile." },
  { no: "03", title: "Aesthetic Clinics", subtitle: "Beauty, presented with restraint." },
  { no: "04", title: "Hair Clinics", subtitle: "Helping confidence grow back." },
  { no: "05", title: "Cosmetic Surgery", subtitle: "Transformative care, thoughtfully presented." },
  { no: "06", title: "Physicians", subtitle: "Trust starts before the appointment." },
  { no: "07", title: "Hospitality", subtitle: "The guest experience starts online." },
  { no: "08", title: "Nonprofits", subtitle: "Stories that move people to act." },
];

export const services = [
  {
    n: '01',
    title: 'Website Design',
    lede: 'Design that behaves like architecture — sight lines, spacing, silence.',
    price: 'Starts at ₹15k',
    bullets: ['Editorial layouts', 'Design systems', 'Interaction design'],
  },
  {
    n: '02',
    title: 'Frontend Development',
    lede: 'Hand-written React that stays fast on the phones patients actually use.',
    bullets: ['React & Next.js', 'Tailwind & Framer Motion', 'Lighthouse-first builds'],
  },
  {
    n: '03',
    title: 'Landing Pages',
    lede: 'Single-page work engineered to convert without shouting.',
    price: 'Starts at ₹10k',
    bullets: ['Conversion structure', 'Copy direction', 'A/B ready blocks'],
  },
  {
    n: '04',
    title: 'UI / UX Design',
    lede: 'Patient-side flows for booking, intake and consultation that feel human.',
    bullets: ['Booking journeys', 'Intake forms', 'Accessibility (WCAG AA)'],
  },
  {
    n: '05',
    title: 'Business Automation',
    lede: 'Quiet automations behind the site — WhatsApp handoffs, form routing, reminders.',
    bullets: ['Form → WhatsApp', 'CRM handoff', 'Reminder flows'],
  },
  {
    n: '06',
    title: 'Technical SEO Foundations',
    lede: 'The kind of SEO that lives in the build, not in a monthly report.',
    bullets: ['Schema & metadata', 'Core Web Vitals', 'Local search hygiene'],
  },
];

export const process = [
  {
    n: 'I',
    title: 'The First Conversation',
    lede: 'A 45-minute call. No decks. We listen for what the clinic sounds like when it\'s at its best.',
  },
  {
    n: 'II',
    title: 'The Written Brief',
    lede: 'Before anything is drawn, everything is written. A document you approve, so the design has no surprises.',
  },
  {
    n: 'III',
    title: 'The Draft in Type',
    lede: 'Layouts in raw typography first — no images, no colour. If it reads well flat, it will read well finished.',
  },
  {
    n: 'IV',
    title: 'The Considered Design',
    lede: 'Full design in Figma, one screen at a time. You see decisions, not moodboards.',
  },
  {
    n: 'V',
    title: 'The Careful Build',
    lede: 'Handwritten React. No page builders. No template debt. Fast on the phones your patients use.',
  },
  {
    n: 'VI',
    title: 'The Quiet Launch',
    lede: 'Launch day is boring on purpose. Redirects, analytics, monitoring — done a week before.',
  },
];

export const faqs = [
  {
    q: 'Do you only work with clinics?',
    a: 'Healthcare is our specialism — it\'s where our details matter most. But we also design for restaurants, nonprofits and event studios when the brief invites care. If your work needs to feel considered, we\'re a fit.',
  },
  {
    q: 'How long does a typical clinic website take?',
    a: 'Most clinic sites take 3 to 5 weeks from written brief to launch. Larger multi-doctor institutes go 6 to 8 weeks. We keep timelines honest, not optimistic.',
  },
  {
    q: 'What does a project cost?',
    a: 'Landing pages start in the low five figures (INR). Full clinic sites and case-study builds are quoted after the first conversation. No packages, no bundles, no upsells.',
  },
  {
    q: 'Do you write the copy?',
    a: 'We direct the copy and write the structure. For clinical content, we work with your practitioner — we never invent medical claims.',
  },
  {
    q: 'What happens after launch?',
    a: 'A 30-day settling period is included: small copy edits, image swaps, analytics review. After that, we offer a light monthly retainer or hand the keys over cleanly. Your call.',
  },
  {
    q: 'Can you redesign an existing website?',
    a: 'Yes. About half of our work is a redesign. We start with a written audit of what your current site is doing well before we touch anything.',
  },
];
